/**
 * @readonly
 * @enum {string}
 */
export const AccelerationEventTypes = Object.freeze({
    ACCELERATION: 'ACCELERATION',
    BRAKE: 'BRAKE',
    STEERING_LEFT: 'STEERING_LEFT',
    STEERING_RIGHT: 'STEERING_RIGHT'
})
